export class UserStaff {
  Id?: string;
  Title: string;
  FirstName: string;
  LastName: string;
  MiddleName?: string;
  UserFacilities: Array<Facility>;
  Email: string;
  Phone: string;
  PhoneNumber: string;
  Username?: string;
  Role: string;
  NPI?: string;
  Credentials?: string;
  Password?: string;
  PasswordConfirmation?: string;
  Visible?: boolean;

  constructor() {
    this.Title = "";
    this.FirstName = "";
    this.LastName = "";
    this.MiddleName = "";
    this.UserFacilities = [];
    this.Email = "";
    this.Phone = "";
    this.PhoneNumber = '';
    this.NPI = '';
    this.Credentials = '';
    this.Role = ''
  }
}

export class UserRole {
  Id: string;
  Name: string;
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/user-staff.model.ts